import React, { ReactNode } from 'react';

import IconSelectButton, { IconButtonProps } from './IconSelectButton';
import useDisplaySize from '../../useDisplaySize';

interface Props {
  title?: ReactNode;
  additionalSelection?: ReactNode;
  options: IconButtonProps[];
}

const IconSelect = ({ options, title, additionalSelection }: Props) => {
  const { isSmallScreen } = useDisplaySize();

  return (
    <div className="icon-select">
      {isSmallScreen && <h2 className="icon-select__title-mobile">{title}</h2>}
      <ul className="icon-select__tools">
        {options.map((option) => (
          <IconSelectButton {...option} key={option.label} />
        ))}
        {additionalSelection}
      </ul>
    </div>
  );
};

export default IconSelect;
